(() => {
  const init = (root) => root.querySelectorAll('.kr-product-video').forEach((wrapper) => {
    const media = wrapper.querySelector('video, iframe');
    const button = wrapper.querySelector('.kr-product-video__play');
    const dialog = wrapper.querySelector('.kr-product-video-dialog');
    if (!media || !button || !dialog || typeof dialog.showModal !== 'function' || wrapper.dataset.krVideoReady) return;
    const player = dialog.querySelector('.kr-product-video-dialog__player');
    const native = media.tagName === 'VIDEO';
    const stop = () => {
      if (native) media.pause();
      else media.removeAttribute('src');
    };
    wrapper.dataset.krVideoReady = 'true';
    button.hidden = false;
    if (!native) media.removeAttribute('src');
    button.addEventListener('click', () => {
      document.querySelectorAll('.kr-product-video-dialog[open]').forEach((other) => {
        if (other === dialog) return;
        other.querySelector('video')?.pause();
        other.querySelector('iframe')?.removeAttribute('src');
        other.close();
      });
      player.append(media);
      dialog.showModal();
      if (native) media.play().then(() => media.focus({ preventScroll: true })).catch(() => {});
      else media.src = media.dataset.krVideoSrc;
    });
    dialog.querySelector('.kr-product-video-dialog__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      stop();
      wrapper.prepend(media);
      if (!document.querySelector('.kr-product-video-dialog[open]')) button.focus({ preventScroll: true });
    });
  });
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
